import { render, staticRenderFns } from "./FileShareManageView.vue?vue&type=template&id=5ca6fc68&scoped=true"
import script from "./FileShareManageView.vue?vue&type=script&lang=js"
export * from "./FileShareManageView.vue?vue&type=script&lang=js"
import style0 from "./FileShareManageView.vue?vue&type=style&index=0&id=5ca6fc68&prod&lang=scss&scoped=true"
import style1 from "./FileShareManageView.vue?vue&type=style&index=1&id=5ca6fc68&prod&lang=scss"
import style2 from "./FileShareManageView.vue?vue&type=style&index=2&id=5ca6fc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6fc68",
  null
  
)

export default component.exports